import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '22',
  viewBox: '-1 -1 26 24',
  fill: '#FFF'
}, [
  h('path', {
    d: 'M23.5 5h-7c-.3 0-.5.2-.5.5s.2.5.5.5H23v3H1V6h6.5c.3 0 .5-.2.5-.5S7.8 5 7.5 5h-7c-.3 0-.5.2-.5.5v16c0 .3.2.5.5.5h23c.3 0 .5-.2.5-.5v-16c0-.3-.2-.5-.5-.5zM1 21V10h22v11H1z'
  }),
  h('path', {
    d: 'M16.5 14h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 16h-6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6c.3 0 .5.2.5.5s-.2.5-.5.5zM17.5 18h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM14.5 8h-5c-.3 0-.5-.2-.5-.5V3c0-1.7 1.3-3 3-3s3 1.3 3 3v4.5c0 .3-.2.5-.5.5zM10 7h4V3c0-1.1-.9-2-2-2s-2 .9-2 2v4zM8.4 15.4c.4-.3.6-.8.6-1.4 0-1.1-.9-2-2-2s-2 .9-2 2c0 .6.2 1.1.6 1.4-.9.6-1.6 1.8-1.6 3.1 0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5 0-1.3-.7-2.5-1.6-3.1zM6 14c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-1 4c.2-1.1 1-2 2-2s1.8.9 2 2H5z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-user-settings.es6.js